import React, { Component } from 'react';
import { observer } from 'mobx-react';
import WhitelabelConfigAuthenticationOptionsService from '../services/WhitelabelConfigAuthenticationOptionsService';
import WhitelabelConfigAuthenticationOptions from './WhitelabelConfigAuthenticationOptions';
import PropTypes from 'prop-types';

class WhitelabelConfigAuthenticationOptionsContainer extends Component {
  static propTypes = {
    whitelabelConfigId: PropTypes.string.isRequired,
  };

  componentDidMount() {
    WhitelabelConfigAuthenticationOptionsService.init(this.props.whitelabelConfigId);
  }

  render() {
    return (
      <WhitelabelConfigAuthenticationOptions
        onChange={WhitelabelConfigAuthenticationOptionsService.updateAppOption}
        disabled={
          WhitelabelConfigAuthenticationOptionsService.fetch.fetching ||
          WhitelabelConfigAuthenticationOptionsService.submit.fetching
        }
        apps={WhitelabelConfigAuthenticationOptionsService.apps}
      />
    );
  }
}

export default observer(WhitelabelConfigAuthenticationOptionsContainer);
